var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245,0C109.9,0,0,109.9,0,245s109.9,245,245,245s245-109.9,245-245S380.1,0,245,0z M245,435c-104.8,0-190-85.2-190-190 S140.2,55,245,55s190,85.2,190,190S349.8,435,245,435z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,105.1c-77.1,0-139.9,62.8-139.9,139.9S167.9,384.9,245,384.9S384.9,322.1,384.9,245S322.1,105.1,245,105.1z  M245,329.9c-46.8,0-84.9-38.1-84.9-84.9s38.1-84.9,84.9-84.9s84.9,38.1,84.9,84.9S291.8,329.9,245,329.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 245,
    r: 36.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.647230f8a7ba45da17d3a920e9738551.svg";
export { ForwardRef as ReactComponent };